import { CLASSES_AND_SPECS, SPECS_TO_HERO_TREES } from "./classes-and-specs";
import { WOW_TREE_DATA_PATH } from "./constants";
import { sigfigFormatter } from "./tierHelper";

export const PATCH = "12.0.7";
export const SEASON = "1";
export const EXPANSION = "Midnight";

export const getIsHealer = (spec) => {
  const healingSpecs = ["restoration", "mistweaver", "holy", "discipline", "preservation"];
  return healingSpecs.includes(spec.toLowerCase());
};

export const getIsTank = (spec) => {
  const tankSpecs = ["protection", "blood", "vengeance", "brewmaster", "guardian"];
  return tankSpecs.includes(spec.toLowerCase());
};

export const getFormattedRole = (role) => {
  switch (role.toLowerCase()) {
    case "dps":
      return "DPS";
    case "heal":
      return "Healer";
    default:
      return "Tank";
  }
};

export const getIcyVeinsRole = (spec) => {
  if (getIsHealer(spec)) {
    return "healing";
  }
  if (getIsTank(spec)) {
    return "tank";
  }
  return "dps";
};

export const getParsedSelectedTalents = (selectedTalentsData) =>
  selectedTalentsData.reduce(
    (acc, item) => {
      const parsedTalent = item.split("#");

      acc.selectedTalents.push(parsedTalent[0]);
      acc.selectedTalentNodeIds.push(parsedTalent[1]);
      acc.selectedTalentsValues.push(parsedTalent[2]);

      return acc;
    },
    { selectedTalents: [], selectedTalentNodeIds: [], selectedTalentsValues: [] },
  );

export const getItemQualityColor = (quality) => {
  switch (quality) {
    case 0: // poor
      return "#9d9d9d";
    case 1: // common
      return "#ffffff";
    case 2: // uncommon
      return "#1eff00";
    case 3: // rare
      return "#0070dd";
    case 4: // epic
      return "#a335ee";
    case 5: // legendary
      return "#ff8000";
    case 6: // artifact
      return "#e6cc80";
    default:
      // heirloom
      return "#00ccff";
  }
};

export const getAbbreviatedClass = (className) => {
  switch (className.toLowerCase()) {
    case "death knight":
      return "DK";
    case "demon hunter":
      return "DH";
    default:
      return className;
  }
};

export const getAbbreviatedSpec = (specName) => {
  switch (specName.toLowerCase()) {
    case "restoration":
      return "Resto";
    case "beast mastery":
      return "BM";
    case "protection":
      return "Prot";
    case "retribution":
      return "Ret";
    case "discipline":
      return "Disc";
    case "demonology":
      return "Demo";
    case "destruction":
      return "Destro";
    default:
      return specName;
  }
};

export const getHeroTalentIconURL = (heroName) => {
  if (!heroName || heroName.trim() === "") return "";

  const modifiedName = heroName
    .split(" ")
    .map((el) => el[0].toUpperCase() + el.slice(1))
    .join("_");

  return `https://static.bigbrain.gg/wow/hero-icons/${modifiedName}.png`;
};

export const getHeroTalentQueryParamFormat = (string) => {
  if (!string || string.trim() === "") return "";

  return string.replace(/'/g, "").replace(/\s/g, "_").toLowerCase();
};

export const getHeroNameFromSelectedTree = (selectedTree, displayClassName, displaySpecName) => {
  return SPECS_TO_HERO_TREES[displayClassName].specs[displaySpecName][selectedTree === "left" ? 0 : 1] ?? "";
};

export const getDataHeroName = (heroName) => {
  if (!heroName || heroName.trim() === "") return "";

  return heroName
    .split(" ")
    .map((el) => el[0].toUpperCase() + el.slice(1))
    .join("")
    .replace(/'/g, "''");
};

export const getFormattedContentType = (type) => {
  if (type?.includes("mythic") ?? false) {
    return "Mythic+";
  } else if (type === "raid") {
    return "VS / DR / MQD / SF";
  } else if (type.toLowerCase() === "pvp") {
    return "PvP";
  }
  return type;
};

// export const getTierSet = (className) => {
//   const tierSets = {
//     "death knight": {
//       name: "Cauldron Champion's Encore",
//       two_piece: {
//         blood: 1215992,
//         frost: 1215727,
//         unholy: 1215726,
//       },
//       four_piece: {
//         blood: 1215993,
//         frost: 1215729,
//         unholy: 1215728,
//       },
//     },
//     "demon hunter": {
//       name: "Fel-Dealer's Contraband",
//       two_piece: {
//         havoc: 1215731,
//         vengeance: 1215990,
//       },
//       four_piece: {
//         havoc: 1215732,
//         vengeance: 1215991,
//       },
//     },
//     druid: {
//       name: "Roots of Reclaiming Blight",
//       two_piece: {
//         balance: 1215695,
//         feral: 1215734,
//         guardian: 1215986,
//         restoration: 1215502,
//       },
//       four_piece: {
//         balance: 1215698,
//         feral: 1215735,
//         guardian: 1215988,
//         restoration: 1215619,
//       },
//     },
//     evoker: {
//       name: "Opulent Treasurescale's Hoard",
//       two_piece: {
//         augmentation: 1215689,
//         devastation: 1215687,
//         preservation: 1215549,
//       },
//       four_piece: {
//         augmentation: 1215691,
//         devastation: 1215692,
//         preservation: 1215610,
//       },
//     },
//     hunter: {
//       name: "Tireless Collector's Bounties",
//       two_piece: {
//         "beast mastery": 1215634,
//         marksmanship: 1215633,
//         survival: 1215730,
//       },
//       four_piece: {
//         "beast mastery": 1215644,
//         marksmanship: 1215645,
//         survival: 1216064,
//       },
//     },
//     mage: {
//       name: "Jewels of the Aspectral Emissary",
//       two_piece: {
//         arcane: 1215136,
//         fire: 1215132,
//         frost: 1215133,
//       },
//       four_piece: {
//         arcane: 1215624,
//         fire: 1215632,
//         frost: 1215629,
//       },
//     },
//     monk: {
//       name: "Ageless Serpent's Foresight",
//       two_piece: {
//         brewmaster: 1215996,
//         mistweaver: 1215543,
//         windwalker: 1215717,
//       },
//       four_piece: {
//         brewmaster: 1215997,
//         mistweaver: 1215609,
//         windwalker: 1215718,
//       },
//     },
//     paladin: {
//       name: "Oath of the Aureate Sentry",
//       two_piece: {
//         holy: 1215533,
//         protection: 1215987,
//         retribution: 1215707,
//       },
//       four_piece: {
//         holy: 1215613,
//         protection: 1215989,
//         retribution: 1215709,
//       },
//     },
//     priest: {
//       name: "Confessor's Unshakable Virtue",
//       two_piece: {
//         discipline: 1215500,
//         holy: 1215319,
//         shadow: 1215702,
//       },
//       four_piece: {
//         discipline: 1215621,
//         holy: 1215623,
//         shadow: 1215703,
//       },
//     },
//     rogue: {
//       name: "Spectral Gambler's Last Call",
//       two_piece: {
//         assassination: 1215719,
//         outlaw: 1215720,
//         subtlety: 1215721,
//       },
//       four_piece: {
//         assassination: 1215724,
//         outlaw: 1215725,
//         subtlety: 1215722,
//       },
//     },
//     shaman: {
//       name: "Currents of the Gale Sovereign",
//       two_piece: {
//         elemental: 1215675,
//         enhancement: 1215710,
//         restoration: 1215538,
//       },
//       four_piece: {
//         elemental: 1215676,
//         enhancement: 1215712,
//         restoration: 1215611,
//       },
//     },
//     warlock: {
//       name: "Spliced Fiendtrader's Influence",
//       two_piece: {
//         affliction: 1215678,
//         demonology: 1215679,
//         destruction: 1215680,
//       },
//       four_piece: {
//         affliction: 1215683,
//         demonology: 1215682,
//         destruction: 1215681,
//       },
//     },
//     warrior: {
//       name: "Underpin Strongarm's Muscle",
//       two_piece: {
//         arms: 1215713,
//         fury: 1215714,
//         protection: 1215994,
//       },
//       four_piece: {
//         arms: 1215716,
//         fury: 1215715,
//         protection: 1215995,
//       },
//     },
//   };

//   return tierSets[className.toLowerCase()];
// };

export const getTierSetMidnight = (className) => {
  const tierSets = {
    death_knight: {
      two_piece: {
        blood: 1264799,
        frost: 1264801,
        unholy: 1264803,
      },
      four_piece: {
        blood: 1264800,
        frost: 1264802,
        unholy: 1264804,
      },
    },
    demon_hunter: {
      two_piece: {
        havoc: 1264805,
        vengeance: 1264808,
        devourer: 1264881,
      },
      four_piece: {
        havoc: 1264807,
        vengeance: 1264809,
        devourer: 1264882,
      },
    },
    druid: {
      two_piece: {
        balance: 1264810,
        feral: 1264812,
        guardian: 1264815,
        restoration: 1264817,
      },
      four_piece: {
        balance: 1264811,
        feral: 1264813,
        guardian: 1264816,
        restoration: 1264818,
      },
    },
    evoker: {
      two_piece: {
        augmentation: 1264819,
        devastation: 1264821,
        preservation: 1264823,
      },
      four_piece: {
        augmentation: 1264820,
        devastation: 1264822,
        preservation: 1264824,
      },
    },
    hunter: {
      two_piece: {
        beast_mastery: 1264825,
        marksmanship: 1264828,
        survival: 1264830,
      },
      four_piece: {
        beast_mastery: 1264826,
        marksmanship: 1264829,
        survival: 1264831,
      },
    },
    mage: {
      two_piece: {
        arcane: 1264832,
        fire: 1264834,
        frost: 1264836,
      },
      four_piece: {
        arcane: 1264833,
        fire: 1264835,
        frost: 1264837,
      },
    },
    monk: {
      two_piece: {
        brewmaster: 1264838,
        mistweaver: 1264840,
        windwalker: 1264842,
      },
      four_piece: {
        brewmaster: 1264839,
        mistweaver: 1264841,
        windwalker: 1264843,
      },
    },
    paladin: {
      two_piece: {
        holy: 1264844,
        protection: 1264846,
        retribution: 1264848,
      },
      four_piece: {
        holy: 1264845,
        protection: 1264847,
        retribution: 1264849,
      },
    },
    priest: {
      two_piece: {
        discipline: 1264850,
        holy: 1264852,
        shadow: 1264854,
      },
      four_piece: {
        discipline: 1264851,
        holy: 1264853,
        shadow: 1264855,
      },
    },
    rogue: {
      two_piece: {
        assassination: 1264856,
        outlaw: 1264858,
        subtlety: 1264860,
      },
      four_piece: {
        assassination: 1264857,
        outlaw: 1264859,
        subtlety: 1264861,
      },
    },
    shaman: {
      two_piece: {
        elemental: 1264862,
        enhancement: 1264864,
        restoration: 1264866,
      },
      four_piece: {
        elemental: 1264863,
        enhancement: 1264865,
        restoration: 1264867,
      },
    },
    warlock: {
      two_piece: {
        affliction: 1264869,
        demonology: 1264871,
        destruction: 1264873,
      },
      four_piece: {
        affliction: 1264870,
        demonology: 1264872,
        destruction: 1264874,
      },
    },
    warrior: {
      two_piece: {
        arms: 1264875,
        fury: 1264877,
        protection: 1264879,
      },
      four_piece: {
        arms: 1264876,
        fury: 1264878,
        protection: 1264880,
      },
    },
  };

  return tierSets[className.toLowerCase()];
};

export const getS3TierSet = (className) => {
  const tierSets = {
    "death knight": {
      two_piece: {
        Deathbringer: 1236253,
        "San'layn": 1236259,
        "Rider of the Apocalypse": 1236355,
      },
      four_piece: {
        Deathbringer: 1236254,
        "San'layn": 1236260,
        "Rider of the Apocalypse": 1236356,
      },
    },
    "demon hunter": {
      two_piece: {
        "Aldrachi Reaver": 1236358,
        "Fel-scarred": 1236361,
      },
      four_piece: {
        "Aldrachi Reaver": 1236360,
        "Fel-scarred": 1236362,
      },
    },
    druid: {
      two_piece: {
        "Elune's Chosen": 1236332,
        "Keeper of the Grove": 1236334,
        "Druid of the Claw": 1236331,
        Wildstalker: 1236337,
      },
      four_piece: {
        "Elune's Chosen": 1236333,
        "Keeper of the Grove": 1236336,
        "Druid of the Claw": 1236330,
        Wildstalker: 1236338,
      },
    },
    evoker: {
      two_piece: {
        Chronowarden: 1236368,
        Scalecommander: 1236366,
        Flameshaper: 1236364,
      },
      four_piece: {
        Chronowarden: 1236369,
        Scalecommander: 1236367,
        Flameshaper: 1236365,
      },
    },
    hunter: {
      two_piece: {
        "Dark Ranger": 1236370,
        "Pack Leader": 1236372,
        Sentinel: 1236374,
      },
      four_piece: {
        "Dark Ranger": 1236371,
        "Pack Leader": 1236373,
        Sentinel: 1236375,
      },
    },
    mage: {
      two_piece: {
        Spellslinger: 1235959,
        Sunfury: 1235962,
        Frostfire: 1235963,
      },
      four_piece: {
        Spellslinger: 1235964,
        Sunfury: 1235965,
        Frostfire: 1235966,
      },
    },
    monk: {
      two_piece: {
        "Master of Harmony": 1236377,
        "Shado-pan": 1236379,
        "Conduit of the Celestials": 1236381,
      },
      four_piece: {
        "Master of Harmony": 1236378,
        "Shado-pan": 1236380,
        "Conduit of the Celestials": 1236382,
      },
    },
    paladin: {
      two_piece: {
        "Herald of the Sun": 1236383,
        Lightsmith: 1236389,
        Templar: 1236391,
      },
      four_piece: {
        "Herald of the Sun": 1236384,
        Lightsmith: 1236390,
        Templar: 1236392,
      },
    },
    priest: {
      two_piece: {
        Oracle: 1236394,
        Archon: 1236398,
        Voidweaver: 1236396,
      },
      four_piece: {
        Oracle: 1236395,
        Archon: 1236399,
        Voidweaver: 1236397,
      },
    },
    rogue: {
      two_piece: {
        Deathstalker: 1236400,
        Fatebound: 1236402,
        Trickster: 1236404,
      },
      four_piece: {
        Deathstalker: 1236401,
        Fatebound: 1236403,
        Trickster: 1236405,
      },
    },
    shaman: {
      two_piece: {
        Farseer: 1236406,
        Stormbringer: 1236408,
        Totemic: 1236410,
      },
      four_piece: {
        Farseer: 1236407,
        Stormbringer: 1236409,
        Totemic: 1236411,
      },
    },
    warlock: {
      two_piece: {
        Hellcaller: 1236413,
        "Soul Harvester": 1236415,
        Diabolist: 1236417,
      },
      four_piece: {
        Hellcaller: 1236414,
        "Soul Harvester": 1236416,
        Diabolist: 1236418,
      },
    },
    warrior: {
      two_piece: {
        Colossus: 1236419,
        Slayer: 1236423,
        "Mountain Thane": 1236421,
      },
      four_piece: {
        Colossus: 1236420,
        Slayer: 1236424,
        "Mountain Thane": 1236422,
      },
    },
  };

  return tierSets[className.toLowerCase()];
};

export const getSpecTreeAccessor = (classType) => {
  // In our specTree we use death_knight whereas the class name is DeathKnight
  const regexp = /[A-Z]/g;
  // find all capital letters
  const array = [...classType.matchAll(regexp)];
  if (array.length <= 1) {
    return classType.toLowerCase();
  } else {
    let splitText = classType;
    for (let i = 1; i < array.length; i++) {
      splitText = splitText.replace(array[i], `_${array[i]}`.toLowerCase());
    }
    return splitText.toLowerCase();
  }
};

export const getSpecTree = (specTrees, classType, spec) => {
  const classAccessor = getSpecTreeAccessor(classType);
  const specAccessor = getSpecTreeAccessor(spec);
  return specTrees[classAccessor][specAccessor];
};

export const getClassTree = (specTrees, classType) => {
  const classAccessor = getSpecTreeAccessor(classType);
  const specAccessor = "common";
  return specTrees[classAccessor][specAccessor];
};

export const getFormattedEncounterType = (encounterType) => {
  if (encounterType === "mythic") {
    encounterType = "mythic+";
  } else if (encounterType === "pvp") {
    encounterType = "PvP";
  }

  return encounterType.slice(0, 1).toUpperCase() + encounterType.slice(1);
};

export const getSeoContentEncounter = (encounterType) => {
  let result = "VS / DR / MQD / SF";
  if (encounterType === "mythic") {
    result = "Mythic +";
  } else if (encounterType === "pvp") {
    result = `Season ${SEASON} PvP`;
  }
  return result;
};

export const getSeoContentEncounterTwo = (encounterType) => {
  let result = "raid";
  if (encounterType === "mythic") {
    result = "m+";
  } else if (encounterType === "pvp") {
    result = "pvp";
  }
  return result;
};

export const getIcyVeinsLinkName = (originalName) => {
  return originalName.split("_").join("-");
};

export const convertDisplayNameToDataName = (displayName) => {
  if (!displayName || displayName.trim() === "") return "";

  switch (displayName.toLowerCase()) {
    case "deathknight":
      return "death_knight";
    case "demonhunter":
      return "demon_hunter";
    case "beastmastery":
      return "beast_mastery";
    default:
      return displayName.toLowerCase().split(" ").join("_");
  }
};

export const isClassHunter = (className) => {
  if (className == "hunter") {
    return "-pet";
  } else {
    return "";
  }
};

export const getDisplayName = (originalName) => {
  if (!originalName || originalName.trim() === "") return "";

  return originalName
    .split("_")
    .map((el) => el[0].toUpperCase() + el.slice(1))
    .join(" ");
};

export const getDataName = (originalName) => {
  if (!originalName || originalName.trim() === "") return "";

  return originalName
    .split("_")
    .map((el) => el[0].toUpperCase() + el.slice(1))
    .join("");
};

export const getFormattedNames = (classType, specType) => {
  const displaySpecName = getDisplayName(specType);
  const displayClassName = getDisplayName(classType);
  const dataSpecName = getDataName(specType);
  const dataClassName = getDataName(classType);

  return { displayClassName, displaySpecName, dataClassName, dataSpecName };
};

export const parseBuildRows = (tree, selectedTalents, rows, sortAsc) => {
  if (!tree) {
    return [];
  }

  let nodes = Object.entries(tree).filter(([key, node]) => selectedTalents.includes(node.id.toString()));

  if (rows !== "all") {
    nodes = nodes.filter(([key, node]) => rows.includes(node.row));
  }

  // Sort by highest row and lowest column. E.g. [10, 5], [10, 8], [10, 17], [9, 5], [9, 9], etc.
  const descCompareFunc = (a, b) => {
    // We multiply by 100 to check rows first. It must be 100 since there are 17 columns, so we can't do 10
    return b[1].row * 100 - a[1].row * 100 + a[1].column - b[1].column;
  };

  // Sort by lowest row and highest column. E.g. [9, 5], [9,9], [10,5], [10,8], [10, 17], etc.
  const ascCompareFunc = (a, b) => {
    // We multiply by 100 to check rows first. It must be 100 since there are 17 columns, so we can't do 10
    return a[1].row * 100 - b[1].row * 100 + b[1].column - a[1].column;
  };

  return sortAsc ? nodes.sort(ascCompareFunc) : nodes.sort(descCompareFunc);
};

export const parseBuildRow = (tree, selectedTalents, row) => {
  return Object.entries(tree).filter(([key, node]) => {
    return node.row == row && selectedTalents.includes(node.id.toString());
  });
};

export const getCapstoneTalents = (tree, selectedTalents) => {
  return parseBuildRow(tree, selectedTalents, 10);
};

export const getChoiceNodes = (tree, selectedTalents) => {
  return Object.entries(tree).filter(([key, node]) => {
    return node.type == 3 && selectedTalents.includes(node.id.toString());
  });
};

export const getClassColor = (displayClassName) => {
  const classData = CLASSES_AND_SPECS.filter((obj) => obj.class === displayClassName);
  return classData[0].color;
};

export const getMainStatData = (encounterType, specType, maxKey, hps, dps) => {
  let mainStat = `+${maxKey}`;
  let statLabel = "Max Key";
  let statTooltip = "The highest key that this particular talent build was used in and completed on time.";

  if (encounterType === "raid") {
    if (getIsHealer(specType)) {
      mainStat = sigfigFormatter(hps);
      statLabel = "HPS";
      statTooltip =
        "HPS is the aggregated Healing Per Second score that each Healer spec does when using this talent build in the top rankings of Raid and Mythic+ Dungeons.";
    } else if (getIsTank(specType)) {
      mainStat = sigfigFormatter(dps);
      statLabel = "Tank DPS";
      statTooltip =
        "For Tanks we opted to show their aggregated DPS score when using this talent build as a temporary placeholder metric while we search for a more valuable metric that tank players care about.";
    } else {
      mainStat = sigfigFormatter(dps);
      statLabel = "DPS";
      statTooltip =
        "DPS is the aggregated Damage Per Second score that each DPS spec does when using this talent build in the top rankings of Raid and Mythic+ Dungeons.";
    }
  }

  return { mainStat, statLabel, statTooltip };
};

export const getSpritesheetUrl = (classType, specType, treeType) => {
  return `${WOW_TREE_DATA_PATH}/assets/${classType}_${specType}.webp`;
};

export const normalizeName = (str) => {
  if (!str) {
    return "";
  }

  return str
    .split(/ |_/)
    .map((x) => x[0].toUpperCase() + x.slice(1))
    .join("");
};

const difficultyPath = {
  all: "all",
  normal: "3",
  heroic: "4",
  mythic: "5",
};

export const getDifficultyPath = (diff, encounterType) => {
  if (!diff) {
    diff = encounterType === "mythic" ? "all" : "heroic";
  }

  // if (!diff) return difficultyPath["mythic"];

  return difficultyPath[diff];
};

export const getSpecOrClassIcon = (isClass, dataClassName, dataSpecName) =>
  isClass
    ? `https://static.bigbrain.gg/wow/class-icons/ClassIcon_${dataClassName}.jpg`
    : `https://static.bigbrain.gg/wow/spec-icons/${dataClassName}-${dataSpecName}.jpg`;

export const getPrimaryStatLabel = (primaryStats) =>
  Object.keys(primaryStats).find((x) => !!primaryStats[x] && parseFloat(primaryStats[x]) !== -1 && x !== "stamina");

export const getFactionFromNum = (num) => (num === 1 ? "alliance" : "horde");

export const getPrimaryStat = (classType, specType) => {
  const primaryStats = {
    DeathKnight: {
      Blood: "Strength",
      Frost: "Strength",
      Unholy: "Strength",
    },
    DemonHunter: {
      Havoc: "Agility",
      Vengeance: "Agility",
      Devourer: "Intellect",
    },
    Druid: {
      Balance: "Intellect",
      Feral: "Agility",
      Guardian: "Agility",
      Restoration: "Intellect",
    },
    Evoker: {
      Augmentation: "Intellect",
      Devastation: "Intellect",
      Preservation: "Intellect",
    },
    Hunter: {
      BeastMastery: "Agility",
      Marksmanship: "Agility",
      Survival: "Agility",
    },
    Mage: {
      Arcane: "Intellect",
      Fire: "Intellect",
      Frost: "Intellect",
    },
    Monk: {
      Brewmaster: "Agility",
      Mistweaver: "Intellect",
      Windwalker: "Agility",
    },
    Paladin: {
      Holy: "Intellect",
      Protection: "Strength",
      Retribution: "Strength",
    },
    Priest: {
      Discipline: "Intellect",
      Holy: "Intellect",
      Shadow: "Intellect",
    },
    Rogue: {
      Assassination: "Agility",
      Outlaw: "Agility",
      Subtlety: "Agility",
    },
    Shaman: {
      Elemental: "Intellect",
      Enhancement: "Agility",
      Restoration: "Intellect",
    },
    Warlock: {
      Affliction: "Intellect",
      Demonology: "Intellect",
      Destruction: "Intellect",
    },
    Warrior: {
      Arms: "Strength",
      Fury: "Strength",
      Protection: "Strength",
    },
  };

  return primaryStats[classType][specType];
};
